export const StatusCodes = {
    '0': 'Cannot provide further status electronically.',
    '1': 'For more detailed information, see remittance advice.',
    '2': 'More detailed information in letter.',
    '3': 'Claim has been adjudicated and is awaiting payment cycle.',
    '4': 'This is a subsequent request for information from the original request.',
    '5': 'This is a final request for information.',
    '6': 'Balance due from the subscriber.',
    '7': 'Claim may be reconsidered at a future date.',
    '8': 'No payment due to contract/plan provisions.',
    '9': 'No payment will be made for this claim.',
    '10': 'All originally submitted procedure codes have been combined.',
    '11': 'Some originally submitted procedure codes have been combined.',
    '12': 'One or more originally submitted procedure codes have been combined.',
    '13': 'All originally submitted procedure codes have been modified.',
    '14': 'Some all originally submitted procedure codes have been modified.',
    '15': 'One or more originally submitted procedure code have been modified.',
    '16': 'Claim/encounter has been forwarded to entity. Usage: This code requires use of an Entity Code.',
    '17':
        'Claim/encounter has been forwarded by third party entity to entity. Usage: This code requires use of an Entity Code.',
    '18':
        'Entity received claim/encounter, but returned invalid status. Usage: This code requires use of an Entity Code.',
    '19': 'Entity acknowledges receipt of claim/encounter. Usage: This code requires use of an Entity Code.',
    '20': 'Accepted for processing.',
    '21':
        'Missing or invalid information. Usage: At least one other status code is required to identify the missing or invalid information.',
    '22': '... before entering the adjudication system.',
    '23': 'Returned to Entity. Usage: This code requires use of an Entity Code.',
    '24': 'Entity not approved as an electronic submitter. Usage: This code requires use of an Entity Code.',
    '25': 'Entity not approved. Usage: This code requires use of an Entity Code.',
    '26': 'Entity not found. Usage: This code requires use of an Entity Code.',
    '27': 'Policy canceled.',
    '28': 'Claim submitted to wrong payer.',
    '29': 'Subscriber and policy number/contract number mismatched.',
    '30': 'Subscriber and subscriber id mismatched.',
    '31': 'Subscriber and policyholder name mismatched.',
    '32': 'Subscriber and policy number/contract number not found.',
    '33': 'Subscriber and subscriber id not found.',
    '34': 'Subscriber and policyholder name not found.',
    '35': 'Claim/encounter not found.',
    '37': 'Predetermination is on file, awaiting completion of services.',
    '38': 'Awaiting next periodic adjudication cycle.',
    '39': 'Charges for pregnancy deferred until delivery.',
    '40': 'Waiting for final approval.',
    '41': 'Special handling required at payer site.',
    '42': 'Awaiting related charges.',
    '44': 'Charges pending provider audit.',
    '45': 'Awaiting benefit determination.',
    '46': 'Internal review/audit.',
    '47': 'Internal review/audit - partial payment made.',
    '48': 'Referral/authorization.',
    '49': 'Pending provider accreditation review.',
    '50': 'Claim waiting for internal provider verification.',
    '51': 'Investigating occupational illness/accident.',
    '52': 'Investigating existence of other insurance coverage.',
    '53': 'Claim being researched for Insured ID/Group Policy Number error.',
    '54': 'Duplicate of a previously processed claim/line.',
    '55': 'Claim assigned to an approver/analyst.',
    '56': 'Awaiting eligibility determination.',
    '57': 'Pending COBRA information requested.',
    '59':
        'Information was requested by a non-electronic method. Usage: At least one other status code is required to identify the requested information.',
    '60':
        'Information was requested by an electronic method. Usage: At least one other status code is required to identify the requested information.',
    '61': 'Eligibility for extended benefits.',
    '64': 'Re-pricing information.',
    '65': 'Claim/line has been paid.',
    '66': 'Payment reflects usual and customary charges.',
    '67': 'Payment made in full.',
    '68': 'Partial payment made for this claim.',
    '69': 'Payment reflects plan provisions.',
    '70': 'Payment reflects contract provisions.',
    '71': 'Periodic installment released.',
    '72': 'Claim contains split payment.',
    '73':
        'Payment made to entity, assignment of benefits not on file. Usage: This code requires use of an Entity Code.',
    '78': 'Duplicate of an existing claim/line, awaiting processing.',
    '81': 'Contract/plan does not cover pre-existing conditions.',
    '83': 'No coverage for newborns.',
    '84': 'Service not authorized.',
    '85': 'Entity not primary. Usage: This code requires use of an Entity Code.',
    '86': 'Diagnosis and patient gender mismatch.',
    '87': 'Denied: Entity not found. (Use code 26 with appropriate Claim Status category Code)',
    '88':
        'Entity not eligible for benefits for submitted dates of service. Usage: This code requires use of an Entity Code.',
    '89':
        'Entity not eligible for dental benefits for submitted dates of service. Usage: This code requires use of an Entity Code.',
    '90':
        'Entity not eligible for medical benefits for submitted dates of service. Usage: This code requires use of an Entity Code.',
    '91': 'Entity not eligible/not approved for dates of service. Usage: This code requires use of an Entity Code.',
    '92': 'Entity does not meet dependent or student qualification. Usage: This code requires use of an Entity Code.',
    '93': 'Entity is not selected primary care provider. Usage: This code requires use of an Entity Code.',
    '94': 'Entity not referred by selected primary care provider. Usage: This code requires use of an Entity Code.',
    '95': 'Requested additional information not received.',
    '96': 'No agreement with entity. Usage: This code requires use of an Entity Code.',
    '97': 'Patient eligibility not found with entity. Usage: This code requires use of an Entity Code.',
    '98': 'Charges applied to deductible.',
    '99': 'Pre-treatment review.',
    '100': 'Pre-certification penalty taken.',
    '101': 'Claim was processed as adjustment to previous claim.',
    '102': "Newborn's charges processed on mother's claim.",
    '103': 'Claim combined with other claim(s).',
    '104':
        'Processed according to plan provisions (Plan refers to provisions that exist between the Health Plan and the Consumer or Patient)',
    '105': 'Claim/line is capitated.',
    '106': "This amount is not entity's responsibility. Usage: This code requires use of an Entity Code.",
    '107':
        'Processed according to contract provisions (Contract refers to provisions that exist between the Health Plan and a Provider of Health Care Services)',
    '108': 'Coverage has been canceled for this entity. (Use code 27)',
    '109': 'Entity not eligible. Usage: This code requires use of an Entity Code.',
    '110': 'Claim requires pricing information.',
    '111': "At the policyholder's request these claims cannot be submitted electronically.",
    '112': 'Policyholder processes their own claims.',
    '113': 'Cannot process individual insurance policy claims.',
    '114': 'Claim/service should be processed by entity. Usage: This code requires use of an Entity Code.',
    '115': 'Cannot process HMO claims',
    '116': 'Claim submitted to incorrect payer.',
    '117': 'Claim requires signature-on-file indicator.',
    '118':
        'TPO rejected claim/line because payer name is missing. (Use status code 21 and status code 125 with entity code IN)',
    '119':
        'TPO rejected claim/line because certification information is missing. (Use status code 21 and status code 252)',
    '120': 'TPO rejected claim/line because claim does not contain enough information. (Use status code 21)',
    '121': 'Service line number greater than maximum allowable for payer.',
    '122': 'Missing/invalid data prevents payer from processing claim. (Use CSC Code 21)',
    '123': 'Additional information requested from entity. Usage: This code requires use of an Entity Code.',
    '124': "Entity's name, address, phone and id number. Usage: This code requires use of an Entity Code.",
    '125': "Entity's name. Usage: This code requires use of an Entity Code.",
    '126': "Entity's address. Usage: This code requires use of an Entity Code.",
    '127': "Entity's Communication Number. Usage: This code requires use of an Entity Code.",
    '128': "Entity's tax id. Usage: This code requires use of an Entity Code.",
    '129': "Entity's Blue Cross provider id. Usage: This code requires use of an Entity Code.",
    '130': "Entity's Blue Shield provider id. Usage: This code requires use of an Entity Code.",
    '131': "Entity's Medicare provider id. Usage: This code requires use of an Entity Code.",
    '132': "Entity's Medicaid provider id. Usage: This code requires use of an Entity Code.",
    '133': "Entity's UPIN. Usage: This code requires use of an Entity Code.",
    '134': "Entity's CHAMPUS provider id. Usage: This code requires use of an Entity Code.",
    '135': "Entity's commercial provider id. Usage: This code requires use of an Entity Code.",
    '136': "Entity's health industry id number. Usage: This code requires use of an Entity Code.",
    '137': "Entity's plan network id. Usage: This code requires use of an Entity Code.",
    '138': "Entity's site id . Usage: This code requires use of an Entity Code.",
    '139': "Entity's health maintenance provider id (HMO). Usage: This code requires use of an Entity Code.",
    '140': "Entity's preferred provider organization id (PPO). Usage: This code requires use of an Entity Code.",
    '141': "Entity's administrative services organization id (ASO). Usage: This code requires use of an Entity Code.",
    '142': "Entity's license/certification number. Usage: This code requires use of an Entity Code.",
    '143': "Entity's state license number. Usage: This code requires use of an Entity Code.",
    '144': "Entity's specialty license number. Usage: This code requires use of an Entity Code.",
    '145': "Entity's specialty/taxonomy code. Usage: This code requires use of an Entity Code.",
    '146': "Entity's anesthesia license number. Usage: This code requires use of an Entity Code.",
    '147':
        "Entity's qualification degree/designation (e.g. RN,PhD,MD). Usage: This code requires use of an Entity Code.",
    '148': "Entity's social security number. Usage: This code requires use of an Entity Code.",
    '149': "Entity's employer id. Usage: This code requires use of an Entity Code.",
    '150': "Entity's drug enforcement agency (DEA) number. Usage: This code requires use of an Entity Code.",
    '152': 'Pharmacy processor number.',
    '153': "Entity's id number. Usage: This code requires use of an Entity Code.",
    '154': 'Relationship of surgeon & assistant surgeon.',
    '155': "Entity's relationship to patient. Usage: This code requires use of an Entity Code.",
    '156': 'Patient relationship to subscriber',
    '157': "Entity's Gender. Usage: This code requires use of an Entity Code.",
    '158': "Entity's date of birth. Usage: This code requires use of an Entity Code.",
    '159': "Entity's date of death. Usage: This code requires use of an Entity Code.",
    '160': "Entity's marital status. Usage: This code requires use of an Entity Code.",
    '161': "Entity's employment status. Usage: This code requires use of an Entity Code.",
    '162': "Entity's health insurance claim number (HICN). Usage: This code requires use of an Entity Code.",
    '163': "Entity's policy/group number. Usage: This code requires use of an Entity Code.",
    '164': "Entity's contract/member number. Usage: This code requires use of an Entity Code.",
    '165': "Entity's employer name, address and phone. Usage: This code requires use of an Entity Code.",
    '166': "Entity's employer name. Usage: This code requires use of an Entity Code.",
    '167': "Entity's employer address. Usage: This code requires use of an Entity Code.",
    '168': "Entity's employer phone number. Usage: This code requires use of an Entity Code.",
    '169': "Entity's employer id.",
    '170': "Entity's employee id. Usage: This code requires use of an Entity Code.",
    '171': 'Other insurance coverage information (health, liability, auto, etc.).',
    '172': 'Other employer name, address and telephone number.',
    '173':
        "Entity's name, address, phone, gender, DOB, marital status, employment status and relation to subscriber. Usage: This code requires use of an Entity Code.",
    '174': "Entity's student status. Usage: This code requires use of an Entity Code.",
    '175': "Entity's school name. Usage: This code requires use of an Entity Code.",
    '176': "Entity's school address. Usage: This code requires use of an Entity Code.",
    '177': "Transplant recipient's name, date of birth, gender, relationship to insured.",
    '178': 'Submitted charges.',
    '179': 'Outside lab charges.',
    '180': 'Hospital s semi-private room rate.',
    '181': 'Hospital s room rate.',
    '182': 'Allowable/paid from other entities coverage Usage: This code requires the use of an entity code.',
    '183': 'Amount entity has paid. Usage: This code requires use of an Entity Code.',
    '184': 'Purchase price for the rented durable medical equipment.',
    '185': 'Rental price for durable medical equipment.',
    '186': 'Purchase and rental price of durable medical equipment.',
    '187': 'Date(s) of service.',
    '188': 'Statement from-through dates.',
    '189': 'Facility admission date',
    '190': 'Facility discharge date',
    '191': 'Date of Last Menstrual Period (LMP)',
    '192': 'Date of first service for current series/symptom/illness.',
    '193': 'First consultation/evaluation date.',
    '194': 'Confinement dates.',
    '195': 'Unable to work dates/Disability Dates.',
    '196': 'Return to work dates.',
    '197': 'Effective coverage date(s).',
    '198': 'Medicare effective date.',
    '199': 'Date of conception and expected date of delivery.',
    '200': 'Date of equipment return.',
    '201': 'Date of dental appliance prior placement.',
    '202': 'Date of dental prior replacement/reason for replacement.',
    '203': 'Date of dental appliance placed.',
    '204': 'Date dental canal(s) opened and date service completed.',
    '205': 'Date(s) dental root canal therapy previously performed.',
    '206': 'Most recent date of curettage, root planing, or periodontal surgery.',
    '207': 'Dental impression and seating date.',
    '208': 'Most recent date pacemaker was implanted.',
    '209': 'Most recent pacemaker battery change date.',
    '210': 'Date of the last x-ray.',
    '211': 'Date(s) of dialysis training provided to patient.',
    '212': 'Date of last routine dialysis.',
    '213': 'Date of first routine dialysis.',
    '214': 'Original date of prescription/orders/referral.',
    '215': 'Date of tooth extraction/evolution.',
    '216': 'Drug information.',
    '217': 'Drug name, strength and dosage form.',
    '218': 'NDC number.',
    '219': 'Prescription number.',
    '220': 'Drug product id number. (Use code 218)',
    '221': 'Drug days supply and dosage.',
    '222': 'Drug dispensing units and average wholesale price (AWP).',
    '223': 'Route of drug/myelogram administration.',
    '224': 'Anatomical location for joint injection.',
    '225': 'Anatomical location.',
    '226': 'Joint injection site.',
    '227': 'Hospital information.',
    '228': 'Type of bill for UB claim',
    '229': 'Hospital admission source.',
    '230': 'Hospital admission hour.',
    '231': 'Hospital admission type.',
    '232': 'Admitting diagnosis.',
    '233': 'Hospital discharge hour.',
    '234': 'Patient discharge status.',
    '235': 'Units of blood furnished.',
    '236': 'Units of blood replaced.',
    '237': 'Units of deductible blood.',
    '238': 'Separate claim for mother/baby charges.',
    '239': 'Dental information.',
    '240': 'Tooth surface(s) involved.',
    '241': 'List of all missing teeth (upper and lower).',
    '242': 'Tooth numbers, surfaces, and/or quadrants involved.',
    '243': 'Months of dental treatment remaining.',
    '244': 'Tooth number or letter.',
    '245': 'Dental quadrant/arch.',
    '246': 'Total orthodontic service fee, initial appliance fee, monthly fee, length of service.',
    '247': 'Line information.',
    '248': 'Accident date, state, description and cause.',
    '249': 'Place of service.',
    '250': 'Type of service.',
    '251': 'Total anesthesia minutes.',
    '252': "Entity's prior authorization/certification number. Usage: This code requires the use of an Entity Code.",
    '253': 'Procedure/revenue code for service(s) rendered. Use codes 454 or 455.',
    '254': 'Principal diagnosis code.',
    '255': 'Diagnosis code.',
    '256': 'DRG code(s).',
    '257': 'ADSM-III-R code for services rendered.',
    '258': 'Days/units for procedure/revenue code.',
    '259': 'Frequency of service.',
    '260': 'Length of medical necessity, including begin date.',
    '261': 'Obesity measurements.',
    '262': 'Type of surgery/service for which anesthesia was administered.',
    '263': 'Length of time for services rendered.',
    '264': 'Number of liters/minute & total hours/day for respiratory support.',
    '265': 'Number of lesions excised.',
    '266': 'Facility point of origin and destination - ambulance.',
    '267': 'Number of miles patient was transported.',
    '268': 'Location of durable medical equipment use.',
    '269': 'Length/size of laceration/tumor.',
    '270': 'Subluxation location.',
    '271': 'Number of spine segments.',
    '272': 'Oxygen contents for oxygen system rental.',
    '273': 'Weight.',
    '274': 'Height.',
    '275': 'Claim.',
    '276': 'UB04/HCFA-1450/1500 claim form',
    '277': 'Paper claim.',
    '278': 'Signed claim form.',
    '279': 'Claim/service must be itemized',
    '280': 'Itemized claim by provider.',
    '281': 'Related confinement claim.',
    '282': 'Copy of prescription.',
    '283': 'Medicare entitlement information is required to determine primary coverage',
    '284': 'Copy of Medicare ID card.',
    '285': 'Vouchers/explanation of benefits (EOB).',
    '286': "Other payer's Explanation of Benefits/payment information.",
    '287': 'Medical necessity for service.',
    '288': 'Hospital late charges',
    '289': 'Reason for late discharge.',
    '290': 'Pre-existing information.',
    '291': 'Reason for termination of pregnancy.',
    '292': 'Purpose of family conference/therapy.',
    '293': 'Reason for physical therapy.',
    '294':
        'Supporting documentation. Usage: At least one other status code is required to identify the supporting documentation.',
    '295': 'Attending physician report.',
    '296': "Nurse's notes.",
    '297': 'Medical notes/report.',
    '298': 'Operative report.',
    '299': 'Emergency room notes/report.',
    '300': 'Lab/test report/notes/results.',
    '301': 'MRI report.',
    '302': 'Refer to codes 300 for lab notes and 311 for pathology notes',
    '303': "Physical therapy notes. Use code 297:6O (6 'OH' - not zero)",
    '304': 'Reports for service.',
    '305': 'Radiology/x-ray reports and/or interpretation',
    '306': 'Detailed description of service.',
    '307': 'Narrative with pocket depth chart.',
    '308': 'Discharge summary.',
    '309': 'Code was duplicate of code 299',
    '310': 'Progress notes for the six months prior to statement date.',
    '311': 'Pathology notes/report.',
    '312': 'Dental charting.',
    '313': 'Bridgework information.',
    '314': 'Dental records for this service.',
    '315': 'Past perio treatment history.',
    '316': 'Complete medical history.',
    '317': "Patient's medical records.",
    '318': 'X-rays/radiology films',
    '319': 'Pre/post-operative x-rays/photographs.',
    '320': 'Study models.',
    '321': 'Radiographs or models. (Use codes 318 and/or 320)',
    '322': 'Recent Full Mouth X-rays',
    '323': 'Study models, x-rays, and/or narrative.',
    '324': 'Recent x-ray of treatment area and/or narrative.',
    '325': 'Recent fm x-rays and/or narrative.',
    '326': 'Copy of transplant acquisition invoice.',
    '327': 'Periodontal case type diagnosis and recent pocket depth chart with narrative.',
    '328': 'Speech therapy notes. Use code 297:6R',
    '329': 'Exercise notes.',
    '330': 'Occupational notes.',
    '331': 'History and physical.',
    '332': 'Authorization/certification (include period covered). (Use code 252)',
    '333': 'Patient release of information authorization.',
    '334': 'Oxygen certification.',
    '335': 'Durable medical equipment certification.',
    '336': 'Chiropractic certification.',
    '337': 'Ambulance certification/documentation.',
    '338': 'Home health certification. Use code 332:4Y',
    '339': 'Enteral/parenteral certification.',
    '340': 'Pacemaker certification.',
    '341': 'Private duty nursing certification.',
    '342': 'Podiatric certification.',
    '343': 'Documentation that facility is state licensed and Medicare approved as a surgical facility.',
    '344': 'Documentation that provider of physical therapy is Medicare Part B approved.',
    '345': 'Treatment plan for service/diagnosis',
    '346': 'Proposed treatment plan for next 6 months.',
    '347': 'Refer to code 345 for treatment plan and code 282 for prescription',
    '348': 'Chiropractic treatment plan. (Use 345:QL)',
    '349': "Psychiatric treatment plan. Use codes 345:5I, 5J, 5K, 5L, 5M, 5N, 5O (5 'OH' - not zero), 5P",
    '350': 'Speech pathology treatment plan. Use code 345:6R',
    '351': "Physical/occupational therapy treatment plan. Use codes 345:6O (6 'OH' - not zero), 6N",
    '352': 'Duration of treatment plan.',
    '353': 'Orthodontics treatment plan.',
    '354': 'Treatment plan for replacement of remaining missing teeth.',
    '355': 'Has claim been paid?',
    '356': 'Was blood furnished?',
    '357': 'Has or will blood be replaced?',
    '358': 'Does provider accept assignment of benefits? (Use code 589)',
    '359': 'Is there a release of information signature on file? (Use code 333)',
    '360': 'Benefits Assignment Certification Indicator',
    '361': 'Is there other insurance?',
    '362': 'Is the dental patient covered by medical insurance?',
    '363': "Possible Workers' Compensation",
    '364': 'Is accident/illness/condition employment related?',
    '365': 'Is service the result of an accident?',
    '366': 'Is injury due to auto accident?',
    '367': 'Is service performed for a recurring condition or new condition?',
    '368': 'Is medical doctor (MD) or doctor of osteopath (DO) on staff of this facility?',
    '369': 'Does patient condition preclude use of ordinary bed?',
    '370': 'Can patient operate controls of bed?',
    '371': 'Is patient confined to room?',
    '372': 'Is patient confined to bed?',
    '373': 'Is patient an insulin diabetic?',
    '374': 'Is prescribed lenses a result of cataract surgery?',
    '375': 'Was refraction performed?',
    '376': 'Was charge for ambulance for a round-trip?',
    '377': 'Was durable medical equipment purchased new or used?',
    '378': 'Is pacemaker temporary or permanent?',
    '379': 'Were services performed supervised by a physician?',
    '380': 'CRNA supervision/medical direction.',
    '381': 'Is drug generic?',
    '382': 'Did provider authorize generic or brand name dispensing?',
    '383': 'Nerve block use (surgery vs. pain management)',
    '384': 'Is prosthesis/crown/inlay placement an initial placement or a replacement?',
    '385': 'Is appliance upper or lower arch & is appliance fixed or removable?',
    '386': 'Orthodontic Treatment/Purpose Indicator',
    '387': 'Date patient last examined by entity. Usage: This code requires use of an Entity Code.',
    '388': 'Date post-operative care assumed',
    '389': 'Date post-operative care relinquished',
    '390': 'Date of most recent medical event necessitating service(s)',
    '391': 'Date(s) dialysis conducted',
    '392': 'Date(s) of blood transfusion(s)',
    '393': 'Date of previous pacemaker check',
    '394': 'Date(s) of most recent hospitalization related to service',
    '395': 'Date entity signed certification/recertification Usage: This code requires use of an Entity Code.',
    '396': 'Date home dialysis began',
    '397': 'Date of onset/exacerbation of illness/condition',
    '398': 'Visual field test results',
    '399': 'Report of prior testing related to this service, including dates',
    '400': 'Claim is out of balance',
    '401': 'Source of payment is not valid',
    '402':
        'Amount must be greater than zero. Usage: At least one other status code is required to identify which amount element is in error.',
    '403':
        'Entity referral notes/orders/prescription. Effective 05/01/2018: Entity referral notes/orders/prescription. Usage: this code requires use of an entity code.',
    '404': 'Specific findings, complaints, or symptoms necessitating service',
    '405': 'Summary of services',
    '406': 'Brief medical history as related to service(s)',
    '407': 'Complications/mitigating circumstances',
    '408': 'Initial certification',
    '409': 'Medication logs/records (including medication therapy)',
    '410': "Explain differences between treatment plan and patient's condition",
    '411': 'Medical necessity for non-routine service(s)',
    '412': 'Medical records to substantiate decision of non-coverage',
    '413': 'Explain/justify differences between treatment plan and services rendered.',
    '414': 'Necessity for concurrent care (more than one physician treating the patient)',
    '415': 'Justify services outside composite rate',
    '416': "Verification of patient's ability to retain and use information",
    '417': 'Prior testing, including result(s) and date(s) as related to service(s)',
    '418': 'Indicating why medications cannot be taken orally',
    '419': 'Individual test(s) comprising the panel and the charges for each test',
    '420': 'Name, dosage and medical justification of contrast material used for radiology procedure',
    '421': 'Medical review attachment/information for service(s)',
    '422': 'Homebound status',
    '423': 'Prognosis',
    '424': 'Statement of non-coverage including itemized bill',
    '425': 'Itemize non-covered services',
    '426': 'All current diagnoses',
    '427': 'Emergency care provided during transport',
    '428': 'Reason for transport by ambulance',
    '429': 'Loaded miles and charges for transport to nearest facility with appropriate services',
    '430': 'Nearest appropriate facility',
    '431': "Patient's condition/functional status at time of service.",
    '432': 'Date benefits exhausted',
    '433': 'Copy of patient revocation of hospice benefits',
    '434': 'Reasons for more than one transfer per entitlement period',
    '435': 'Notice of Admission',
    '436': 'Short term goals',
    '437': 'Long term goals',
    '438': 'Number of patients attending session',
    '439': 'Size, depth, amount, and type of drainage wounds',
    '440': 'why non-skilled caregiver has not been taught procedure',
    '441': 'Entity professional qualification for service(s)',
    '442': 'Modalities of service',
    '443': 'Initial evaluation report',
    '444': 'Method used to obtain test sample',
    '445': 'Explain why hearing loss not correctable by hearing aid',
    '446': 'Documentation from prior claim(s) related to service(s)',
    '447': 'Plan of teaching',
    '448':
        'Invalid billing combination. See STC12 for details. This code should only be used to indicate an inconsistency between two or more data elements on the claim. A detailed explanation is required in STC12 when this code is used.',
    '449': 'Projected date to discontinue service(s)',
    '450': 'Awaiting spend down determination',
    '451': 'Preoperative and post-operative diagnosis',
    '452': 'Total visits in total number of hours/day and total number of hours/week',
    '453': 'Procedure Code Modifier(s) for Service(s) Rendered',
    '454': 'Procedure code for services rendered.',
    '455': 'Revenue code for services rendered.',
    '456': 'Covered Day(s)',
    '457': 'Non-Covered Day(s)',
    '458': 'Coinsurance Day(s)',
    '459': 'Lifetime Reserve Day(s)',
    '460': 'NUBC Condition Code(s)',
    '461': 'NUBC Occurrence Code(s) and Date(s)',
    '462': 'NUBC Occurrence Span Code(s) and Date(s)',
    '463': 'NUBC Value Code(s) and/or Amount(s)',
    '464': 'Payer Assigned Claim Control Number',
    '465': 'Principal Procedure Code for Service(s) Rendered',
    '466': "Entity's Original Signature. Usage: This code requires use of an Entity Code.",
    '467': 'Entity Signature Date. Usage: This code requires use of an Entity Code.',
    '468': 'Patient Signature Source',
    '469': 'Purchase Service Charge',
    '470': 'Was service purchased from another entity? Usage: This code requires use of an Entity Code.',
    '471': 'Were services related to an emergency?',
    '472': 'Ambulance Run Sheet',
    '473': 'Missing or invalid lab indicator',
    '474': 'Procedure code and patient gender mismatch',
    '475': 'Procedure code not valid for patient age',
    '476': 'Missing or invalid units of service',
    '477': 'Diagnosis code pointer is missing or invalid',
    '478': "Claim submitter's identifier",
    '479': 'Other Carrier payer ID is missing or invalid',
    '480': "Entity's claim filing indicator. Usage: This code requires use of an Entity Code.",
    '481': 'Claim/submission format is invalid.',
    '482': 'Date Error, Century Missing',
    '483': 'Maximum coverage amount met or exceeded for benefit period.',
    '484': 'Business Application Currently Not Available',
    '485':
        'More information available than can be returned in real time mode. Narrow your current search criteria. This change effective September 1, 2017: More information available than can be returned in real-time mode. Narrow your current search criteria.',
    '486': 'Principal Procedure Date',
    '487':
        "Claim not found, claim should have been submitted to/through 'entity'. Usage: This code requires use of an Entity Code.",
    '488': 'Diagnosis code(s) for the services rendered.',
    '489': 'Attachment Control Number',
    '490': 'Other Procedure Code for Service(s) Rendered',
    '491': 'Entity not eligible for encounter submission. Usage: This code requires use of an Entity Code.',
    '492': 'Other Procedure Date',
    '493': 'Version/Release/Industry ID code not currently supported by information holder',
    '494':
        'Real-Time requests not supported by the information holder, resubmit as batch request This change effective September 1, 2017: Real-time requests not supported by the information holder, resubmit as batch request',
    '495':
        'Requests for re-adjudication must reference the newly assigned payer claim control number for this previously adjusted claim. Correct the payer claim control number and re-submit.',
    '496':
        'Submitter not approved for electronic claim submissions on behalf of this entity. Usage: This code requires use of an Entity Code.',
    '497': 'Sales tax not paid',
    '498': 'Maximum leave days exhausted',
    '499':
        'No rate on file with the payer for this service for this entity Usage: This code requires use of an Entity Code.',
    '500': "Entity's Postal/Zip Code. Usage: This code requires use of an Entity Code.",
    '501': "Entity's State/Province. Usage: This code requires use of an Entity Code.",
    '502': "Entity's City. Usage: This code requires use of an Entity Code.",
    '503': "Entity's Street Address. Usage: This code requires use of an Entity Code.",
    '504': "Entity's Last Name. Usage: This code requires use of an Entity Code.",
    '505': "Entity's First Name. Usage: This code requires use of an Entity Code.",
    '506':
        'Entity is changing processor/clearinghouse. This claim must be submitted to the new processor/clearinghouse. Usage: This code requires use of an Entity Code.',
    '507': 'HCPCS',
    '508':
        'ICD9 Usage: At least one other status code is required to identify the related procedure code or diagnosis code.',
    '509': 'External Cause of Injury Code.',
    '510': 'Future date. Usage: At least one other status code is required to identify the data element in error.',
    '511':
        'Invalid character. Usage: At least one other status code is required to identify the data element in error.',
    '512':
        "Length invalid for receiver's application system. Usage: At least one other status code is required to identify the data element in error.",
    '513': 'HIPPS Rate Code for services Rendered',
    '514': "Entity's Middle Name Usage: This code requires use of an Entity Code.",
    '515': 'Managed Care review',
    '516':
        "Other Entity's Adjudication or Payment/Remittance Date. Usage: An Entity code is required to identify the Other Payer Entity, i.e. primary, secondary.",
    '517': 'Adjusted Repriced Claim Reference Number',
    '518': 'Adjusted Repriced Line item Reference Number',
    '519': 'Adjustment Amount',
    '520': 'Adjustment Quantity',
    '521': 'Adjustment Reason Code',
    '522': 'Anesthesia Modifying Units',
    '523': 'Anesthesia Unit Count',
    '524': 'Arterial Blood Gas Quantity',
    '525': 'Begin Therapy Date',
    '526': 'Bundled or Unbundled Line Number',
    '527': 'Certification Condition Indicator',
    '528': 'Certification Period Projected Visit Count',
    '529': 'Certification Revision Date',
    '530': 'Claim Adjustment Indicator',
    '531': 'Claim Disproportinate Share Amount',
    '532': 'Claim DRG Amount',
    '533': 'Claim DRG Outlier Amount',
    '534': 'Claim ESRD Payment Amount',
    '535': 'Claim Frequency Code',
    '536': 'Claim Indirect Teaching Amount',
    '537': 'Claim MSP Pass-through Amount',
    '538': 'Claim or Encounter Identifier',
    '539': 'Claim PPS Capital Amount',
    '540': 'Claim PPS Capital Outlier Amount',
    '541': 'Claim Submission Reason Code',
    '542': 'Claim Total Denied Charge Amount',
    '543': 'Clearinghouse or Value Added Network Trace',
    '544': 'Clinical Laboratory Improvement Amendment (CLIA) Number',
    '545': 'Contract Amount',
    '546': 'Contract Code',
    '547': 'Contract Percentage',
    '548': 'Contract Type Code',
    '549': 'Contract Version Identifier',
    '550': 'Coordination of Benefits Code',
    '551': 'Coordination of Benefits Total Submitted Charge',
    '552': 'Cost Report Day Count',
    '553': 'Covered Amount',
    '554': 'Date Claim Paid',
    '555': 'Delay Reason Code',
    '556': 'Demonstration Project Identifier',
    '557': 'Diagnosis Date',
    '558': 'Discount Amount',
    '559': 'Document Control Identifier',
    '560': "Entity's Additional/Secondary Identifier. Usage: This code requires use of an Entity Code.",
    '561': "Entity's Contact Name. Usage: This code requires use of an Entity Code.",
    '562': "Entity's National Provider Identifier (NPI). Usage: This code requires use of an Entity Code.",
    '563': "Entity's Tax Amount. Usage: This code requires use of an Entity Code.",
    '564': 'EPSDT Indicator',
    '565': 'Estimated Claim Due Amount',
    '566': 'Exception Code',
    '567': 'Facility Code Qualifier',
    '568': 'Family Planning Indicator',
    '569': 'Fixed Format Information',
    '570': 'Free Form Message Text',
    '571': 'Frequency Count',
    '572': 'Frequency Period',
    '573': 'Functional Limitation Code',
    '574': 'HCPCS Payable Amount Home Health',
    '575': 'Homebound Indicator',
    '576': 'Immunization Batch Number',
    '577': 'Industry Code',
    '578': 'Insurance Type Code',
    '579': 'Investigational Device Exemption Identifier',
    '580': 'Last Certification Date',
    '581': 'Last Worked Date',
    '582': 'Lifetime Psychiatric Days Count',
    '583': 'Line Item Charge Amount',
    '584': 'Line Item Control Number',
    '585': 'Denied Charge or Non-covered Charge',
    '586': 'Line Note Text',
    '587': 'Measurement Reference Identification Code',
    '588': 'Medical Record Number',
    '589': 'Provider Accept Assignment Code',
    '590': 'Medicare Coverage Indicator',
    '591': 'Medicare Paid at 100% Amount',
    '592': 'Medicare Paid at 80% Amount',
    '593': 'Medicare Section 4081 Indicator',
    '594': 'Mental Status Code',
    '595': 'Monthly Treatment Count',
    '596': 'Non-covered Charge Amount',
    '597': 'Non-payable Professional Component Amount',
    '598': 'Non-payable Professional Component Billed Amount',
    '599': 'Note Reference Code',
    '600': 'Oxygen Saturation Qty',
    '601': 'Oxygen Test Condition Code',
    '602': 'Oxygen Test Date',
    '603': 'Old Capital Amount',
    '604': 'Originator Application Transaction Identifier',
    '605': 'Orthodontic Treatment Months Count',
    '606': 'Paid From Part A Medicare Trust Fund Amount',
    '607': 'Paid From Part B Medicare Trust Fund Amount',
    '608': 'Paid Service Unit Count',
    '609': 'Participation Agreement',
    '610': 'Patient Discharge Facility Type Code',
    '611': 'Peer Review Authorization Number',
    '612': 'Per Day Limit Amount',
    '613': 'Physician Contact Date',
    '614': 'Physician Order Date',
    '615': 'Policy Compliance Code',
    '616': 'Policy Name',
    '617': 'Postage Claimed Amount',
    '618': 'PPS-Capital DSH DRG Amount',
    '619': 'PPS-Capital Exception Amount',
    '620': 'PPS-Capital FSP DRG Amount',
    '621': 'PPS-Capital HSP DRG Amount',
    '622': 'PPS-Capital IME Amount',
    '623': 'PPS-Operating Federal Specific DRG Amount',
    '624': 'PPS-Operating Hospital Specific DRG Amount',
    '625': 'Predetermination of Benefits Identifier',
    '626': 'Pregnancy Indicator',
    '627': 'Pre-Tax Claim Amount',
    '628': 'Pricing Methodology',
    '629': 'Property Casualty Claim Number',
    '630': 'Referring CLIA Number',
    '631': 'Reimbursement Rate',
    '632': 'Reject Reason Code',
    '633': 'Related Causes Code (Accident, auto accident, employment)',
    '634': 'Remark Code',
    '635': 'Repriced Ambulatory Patient Group Code',
    '636': 'Repriced Line Item Reference Number',
    '637': 'Repriced Saving Amount',
    '638': 'Repricing Per Diem or Flat Rate Amount',
    '639': 'Responsibility Amount',
    '640': 'Sales Tax Amount',
    '641': 'Service Adjudication or Payment Date. Note: Use code 516.',
    '642': 'Service Authorization Exception Code',
    '643': 'Service Line Paid Amount',
    '644': 'Service Line Rate',
    '645': 'Service Tax Amount',
    '646': 'Ship, Delivery or Calendar Pattern Code',
    '647': 'Shipped Date',
    '648': 'Similar Illness or Symptom Date',
    '649': 'Skilled Nursing Facility Indicator',
    '650': 'Special Program Indicator',
    '651': 'State Industrial Accident Provider Number',
    '652': 'Terms Discount Percentage',
    '653': 'Test Performed Date',
    '654': 'Total Denied Charge Amount',
    '655': 'Total Medicare Paid Amount',
    '656': 'Total Visits Projected This Certification Count',
    '657': 'Total Visits Rendered Count',
    '658': 'Treatment Code',
    '659': 'Unit or Basis for Measurement Code',
    '660': 'Universal Product Number',
    '661': 'Visits Prior to Recertification Date Count CR702',
    '662': 'X-ray Availability Indicator',
    '663': "Entity's Group Name. Usage: This code requires use of an Entity Code.",
    '664': 'Orthodontic Banding Date',
    '665': 'Surgery Date',
    '666': 'Surgical Procedure Code',
    '667':
        'Real-Time requests not supported by the information holder, do not resubmit This change effective September 1, 2017: Real-time requests not supported by the information holder, do not resubmit',
    '668': 'Missing Endodontics treatment history and prognosis',
    '669': 'Dental service narrative needed.',
    '670':
        'Funds applied from a consumer spending account such as consumer directed/driven health plan (CDHP), Health savings account (H S A) and or other similar accounts',
    '671':
        'Funds may be available from a consumer spending account such as consumer directed/driven health plan (CDHP), Health savings account (H S A) and or other similar accounts',
    '672': "Other Payer's payment information is out of balance",
    '673': 'Patient Reason for Visit',
    '674': 'Authorization exceeded',
    '675': 'Facility admission through discharge dates',
    '676': 'Entity possibly compensated by facility. Usage: This code requires use of an Entity Code.',
    '677': 'Entity not affiliated. Usage: This code requires use of an Entity Code.',
    '678': 'Revenue code and patient gender mismatch',
    '679': "Submit newborn services on mother's claim",
    '680': "Entity's Country. Usage: This code requires use of an Entity Code.",
    '681': 'Claim currency not supported',
    '682': 'Cosmetic procedure',
    '683': 'Awaiting Associated Hospital Claims',
    '684':
        "Rejected. Syntax error noted for this claim/service/inquiry. See Functional or Implementation Acknowledgement for details. (Usage: Only for use to reject claims or status requests in transactions that were 'accepted with errors' on a 997 or 999 Acknowledgement.)",
    '685':
        'Claim could not complete adjudication in real time. Claim will continue processing in a batch mode. Do not resubmit. This change effective September 1, 2017: Claim could not complete adjudication in real-time. Claim will continue processing in a batch mode. Do not resubmit.',
    '686': 'The claim/ encounter has completed the adjudication cycle and the entire claim has been voided',
    '687':
        'Claim estimation can not be completed in real time. Do not resubmit. This change effective September 1, 2017: Claim predetermination/estimation could not be completed in real-time. Do not resubmit.',
    '688': 'Present on Admission Indicator for reported diagnosis code(s).',
    '689':
        'Entity was unable to respond within the expected time frame. Usage: This code requires use of an Entity Code.',
    '690':
        'Multiple claims or estimate requests cannot be processed in real time. This change effective September 1, 2017: Multiple claims or estimate requests cannot be processed in real-time.',
    '691':
        'Multiple claim status requests cannot be processed in real time. This change effective September 1, 2017: Multiple claim status requests cannot be processed in real-time.',
    '692': 'Contracted funding agreement-Subscriber is employed by the provider of services',
    '693':
        'Amount must be greater than or equal to zero. Usage: At least one other status code is required to identify which amount element is in error.',
    '694':
        'Amount must not be equal to zero. Usage: At least one other status code is required to identify which amount element is in error.',
    '695': "Entity's Country Subdivision Code. Usage: This code requires use of an Entity Code.",
    '696': 'Claim Adjustment Group Code.',
    '697':
        'Invalid Decimal Precision. Usage: At least one other status code is required to identify the data element in error.',
    '698': 'Form Type Identification',
    '699': 'Question/Response from Supporting Documentation Form',
    '700':
        'ICD10. Usage: At least one other status code is required to identify the related procedure code or diagnosis code.',
    '701': 'Initial Treatment Date',
    '702': 'Repriced Claim Reference Number',
    '703': 'Advanced Billing Concepts (ABC) code',
    '704': 'Claim Note Text',
    '705': 'Repriced Allowed Amount',
    '706': 'Repriced Approved Amount',
    '707': 'Repriced Approved Ambulatory Patient Group Amount',
    '708': 'Repriced Approved Revenue Code',
    '709': 'Repriced Approved Service Unit Count',
    '710':
        'Line Adjudication Information. Usage: At least one other status code is required to identify the data element in error.',
    '711': 'Stretcher purpose',
    '712': 'Obstetric Additional Units',
    '713': 'Patient Condition Description',
    '714': 'Care Plan Oversight Number',
    '715': 'Acute Manifestation Date',
    '716': 'Repriced Approved DRG Code',
    '717': 'This claim has been split for processing.',
    '718': 'Claim/service not submitted within the required timeframe (timely filing).',
    '719': 'NUBC Occurrence Code(s)',
    '720': 'NUBC Occurrence Code Date(s)',
    '721': 'NUBC Occurrence Span Code(s)',
    '722': 'NUBC Occurrence Span Code Date(s)',
    '723': 'Drug days supply',
    '724': 'Drug dosage. This change effective 5/01/2017: Drug Quantity',
    '725': 'NUBC Value Code(s)',
    '726': 'NUBC Value Code Amount(s)',
    '727': 'Accident date',
    '728': 'Accident state',
    '729': 'Accident description',
    '730': 'Accident cause',
    '731': 'Measurement value/test result',
    '732':
        'Information submitted inconsistent with billing guidelines. Usage: At least one other status code is required to identify the inconsistent information.',
    '733': "Prefix for entity's contract/member number.",
    '734': 'Verifying premium payment',
    '735': 'This service/claim is included in the allowance for another service or claim.',
    '736': 'A related or qualifying service/claim has not been received/adjudicated.',
    '737': 'Current Dental Terminology (CDT) Code',
    '738': 'Home Infusion EDI Coalition (HEIC) Product/Service Code',
    '739': 'Jurisdiction Specific Procedure or Supply Code',
    '740': 'Drop-Off Location',
    '741': 'Entity must be a person. Usage: This code requires use of an Entity Code.',
    '742': 'Payer Responsibility Sequence Number Code',
    '743': "Entity's credential/enrollment information. Usage: This code requires use of an Entity Code.",
    '744': 'Services/charges related to the treatment of a hospital-acquired condition or preventable medical error.',
    '745':
        'Identifier Qualifier Usage: At least one other status code is required to identify the specific identifier qualifier in error.',
    '746':
        'Duplicate Submission Usage: use only at the information receiver level in the Health Care Claim Acknowledgement transaction.',
    '747': 'Hospice Employee Indicator',
    '748': 'Corrected Data Usage: Requires a second status code to identify the corrected data.',
    '749': 'Date of Injury/Illness',
    '750': 'Auto Accident State or Province Code',
    '751': 'Ambulance Pick-up State or Province Code',
    '752': 'Ambulance Drop-off State or Province Code',
    '753': 'Co-pay status code.',
    '754': 'Entity Name Suffix. Usage: This code requires the use of an Entity Code.',
    '755': "Entity's primary identifier. Usage: This code requires the use of an Entity Code.",
    '756': "Entity's Received Date. Usage: This code requires the use of an Entity Code.",
    '757': 'Last seen date.',
    '758': 'Repriced approved HCPCS code.',
    '759': 'Round trip purpose description.',
    '760': 'Tooth status code.',
    '761': "Entity's referral number. Usage: This code requires the use of an Entity Code.",
    '762': 'Locum Tenens Provider Identifier. Code must be used with Entity Code 82 - Rendering Provider',
    '763': 'Ambulance Pickup ZipCode',
    '764': 'Professional charges are non covered.',
    '765': 'Institutional charges are non covered.',
    '766': 'Services were performed during a Health Insurance Exchange (HIX) premium payment grace period.',
    '767': 'Qualifications for emergent/urgent care',
    '768': 'Service date outside the accidental injury coverage period.',
    '769': 'DME Repair or Maintenance',
    '770': 'Duplicate of a claim processed or in process as a crossover/coordination of benefits claim.',
    '771': 'Claim submitted prematurely. Please resubmit after crossover/payer to payer COB allotted waiting period.',
    '772': 'The greatest level of diagnosis code specificity is required.',
    '773': 'One calendar year per claim.',
    '774': 'Experimental/Investigational',
    '775': 'Entity Type Qualifier (Person/Non-Person Entity). Usage: this code requires use of an entity code.',
    '776': 'Pre/Post-operative care',
    '777': 'Processed based on multiple or concurrent procedure rules.',
    '778': 'Non-Compensable incident/event. Usage: To be used for Property and Casualty only.',
    '779': 'Service submitted for the same/similar service within a set timeframe.',
    '780': 'Lifetime benefit maximum',
    '781': 'Claim has been identified as a readmission',
    '782': 'Second surgical opinion',
    '783': 'Federal sequestration adjustment',
    '784': 'Electronic Visit Verification criteria do not match.',
    '785': 'Missing/Invalid Sterilization/Abortion/Hospital Consent Form.',
    '786': 'Submit claim to the third party property and casualty automobile insurer.',
    '787': 'Resubmit a new claim, not a replacement claim.',
    '788': "Submit these services to the patient's Pharmacy Plan for further consideration.",
    '789': "Submit these services to the patient's Medical Plan for further consideration.",
    '790': "Submit these services to the patient's Dental Plan for further consideration.",
    '791': "Submit these services to the patient's Vision Plan for further consideration.",
    '792': "Submit these services to the patient's Behavioral Health Plan for further consideration.",
    '793': "Submit these services to the patient's Property and Casualty Plan for further consideration.",
    '794': 'Claim could not complete adjudication in real time. Resubmit as a batch request.',
    '795': 'Claim submitted prematurely. Please provide the prior payer’s final adjudication.',
};

export function getStatusCode(key: string | undefined) {
    if (!key) {
        return undefined;
    }

    const value = (StatusCodes as any)[key];
    return value ? `[${key}] ${value}` : key;
}
